import { render, staticRenderFns } from "./CompanyDesktopTakenTable.vue?vue&type=template&id=18c21e38"
import script from "./CompanyDesktopTakenTable.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopTakenTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyDesktopTakenTable.vue?vue&type=style&index=0&id=18c21e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports